import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  Button,
  Checkbox,
  ComboModalidadeTermo,
  Dropdown,
  Radio,
  Text,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';

// #region Import Componentes
import DatePicker from '../../components/molecules/DatePicker';

// #endregion

import LabelContainer from '../../components/molecules/LabelContainer';
import {
  ComboDatePicker,
  ContButton,
  FormContainer,
  InlineContainer,
} from './styles';

function FormRelatorioBeneficiario({
  formParams,
  setFormParams,
  grupoContratante,
  clearParams,
  handleNovoRelatorio,
}) {
  const { response } = useSelector((state) => state.modalidade);
  const modalidades = response;

  const optionsTipoLayout = [
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          layout: 'Layout 1',
        }));
      },
      text: 'Layout 1',
    },
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          layout: 'Layout 2',
        }));
      },
      text: 'Layout 2',
    },
  ];

  const optionsTipoExtensao = [
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          extensao: 'xlsx',
        }));
      },
      text: 'xlsx',
    },
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          extensao: 'txt',
        }));
      },
      text: 'txt',
    },
  ];

  function handleDataPeriodoDeReferenciaDe(e) {
    if (e.target) return;
    const dataPeriodoDeReferenciaAte =
      e > formParams.dataPeriodoDeReferenciaAte
        ? e
        : formParams.dataPeriodoDeReferenciaAte;

    setFormParams((oldValue) => ({
      ...oldValue,
      dataPeriodoDeReferenciaDe: e,
      dataPeriodoDeReferenciaAte,
    }));
  }
  function handleDataPeriodoDeReferenciaAte(e) {
    if (e.target) return;

    setFormParams((oldValue) => ({
      ...oldValue,
      dataPeriodoDeReferenciaDe: formParams.dataPeriodoDeReferenciaDe,
      dataPeriodoDeReferenciaAte:
        e < formParams.dataPeriodoDeReferenciaDe
          ? formParams.dataPeriodoDeReferenciaDe
          : e,
    }));
  }

  const shapeModalidades = useCallback(
    (modalidadesParam) =>
      modalidadesParam.map((modalidade) => ({
        text: modalidade.codigoModalidade.toString(),
        termos: modalidade.termos.map((termo) => termo.codigoTermo.toString()),
      })),
    []
  );

  function handleChangeInput(e) {
    const { name, value } = e.target;
    setFormParams((oldValue) => ({ ...oldValue, [name]: value }));
  }

  function handleChangeKeyValue(key, value) {
    if (value.target) return;
    if (!value) return;

    setFormParams((oldValue) => ({ ...oldValue, [key]: value }));
  }

  function handleSelectedTipoConsulta(tipoConsulta) {
    const tipoInativos =
      tipoConsulta === 3 ? { modalidade: '', termo: '' } : null;

    setFormParams((oldValue) => ({
      ...oldValue,
      tipoConsulta,
      ...tipoInativos,
    }));
  }

  function handleCheckDataExclusaoProgramada() {
    setFormParams((oldValue) => ({
      ...oldValue,
      exclusaoProgramada: !formParams.exclusaoProgramada,
    }));
  }
  function handleSelectedGrupoContratante() {
    setFormParams((oldValue) => ({
      ...oldValue,
      grupoContrantante:
        grupoContratante.nomeComplemento &&
        !formParams.consultaPorGrupoContratante
          ? grupoContratante.nomeComplemento
          : '',
      consultaPorGrupoContratante: !formParams.consultaPorGrupoContratante,
      modalidade: '',
      termo: '',
    }));
  }
  return (
    <FormContainer>
      <InlineContainer>
        <Radio
          label="Beneficiário Ativo"
          checked={formParams.tipoConsulta === 1}
          colorChecked="#00995D"
          onClick={() => handleSelectedTipoConsulta(1)}
        />
        <Radio
          label="Beneficiário Excluído"
          checked={formParams.tipoConsulta === 2}
          colorChecked="#00995D"
          onClick={() => handleSelectedTipoConsulta(2)}
        />
        {modalidades.some(
          (modalidade) =>
            modalidade.codigoModalidade === 36 ||
            modalidade.codigoModalidade === 38 ||
            modalidade.codigoModalidade === 34
        ) && (
          <Radio
            label="Beneficiário Inativo"
            checked={formParams.tipoConsulta === 3}
            colorChecked="#00995D"
            onClick={() => handleSelectedTipoConsulta(3)}
          />
        )}
      </InlineContainer>

      <WrapperFlex>
        <TextField
          name="contratante"
          labelText="Código da Contratante"
          width={180}
          placeholder="Código da Contratante"
          font="14px 'Calibri Regular'"
          value={
            formParams.consultaPorGrupoContratante
              ? ' '
              : formParams?.contratante
          }
          onChange={(e) => handleChangeInput(e)}
          height={40}
          disabled
        />
        <ComboModalidadeTermo
          modalidade={formParams?.modalidade || ''}
          setModalidade={(value) => handleChangeKeyValue('modalidade', value)}
          termo={formParams?.termo || ''}
          setTermo={(value) => handleChangeKeyValue('termo', value)}
          modalidades={
            formParams.consultaPorGrupoContratante ||
            formParams.tipoConsulta === 3
              ? null
              : shapeModalidades(modalidades)
          }
          height={40}
        />
      </WrapperFlex>

      <WrapperFlex>
        <Dropdown
          options={optionsTipoLayout}
          name="layout"
          labelText="Layout"
          width={180}
          height={40}
          font="13px 'Calibri Regular'"
        >
          {formParams.layout}
        </Dropdown>
        <Dropdown
          options={optionsTipoExtensao}
          name="extensão"
          labelText="Extensão"
          width={180}
          height={40}
          font="13px 'Calibri Regular'"
        >
          {formParams.extensao}
        </Dropdown>
      </WrapperFlex>
      {grupoContratante?.nomeComplemento && (
        <WrapperFlex alignCenter marginLeft={6} marginTop={10} gap={10}>
          <Checkbox
            colorChecked="#00995D"
            onChecked={() => handleSelectedGrupoContratante()}
            checked={formParams.consultaPorGrupoContratante}
          />
          <Text
            font="bold 16px/14px Calibri"
            text="Grupo Contratante"
            font="13px 'Calibri Regular'"
          />
        </WrapperFlex>
      )}
      {formParams?.tipoConsulta === 1 && (
        // Beneficiário Ativo

        <WrapperFlex marginLeft={6} alignCenter gap={10} marginTop={5}>
          <Checkbox
            colorChecked="#00995D"
            onChecked={() => handleCheckDataExclusaoProgramada()}
            checked={formParams.exclusaoProgramada}
          />
          <Text
            font="bold 16px/14px Calibri"
            text="Beneficiário com data exclusão programada"
            font="13px 'Calibri Regular'"
          />
        </WrapperFlex>
      )}
      {formParams?.tipoConsulta === 2 && (
        // Beneficiário Excluído

        <LabelContainer text="Período de referência">
          <ComboDatePicker>
            <DatePicker
              name="dataCriacaoDe"
              onChange={handleDataPeriodoDeReferenciaDe}
              value={formParams.dataPeriodoDeReferenciaDe}
              required
            />
            <p>à</p>
            <DatePicker
              onChange={handleDataPeriodoDeReferenciaAte}
              name="dataCriacaoAte"
              minDate={formParams.dataPeriodoDefeRerenciaDe}
              value={formParams.dataPeriodoDeReferenciaAte}
              required
            />
          </ComboDatePicker>
        </LabelContainer>
      )}
      <ContButton>
        <Button
          tipo="secondary"
          paddingTop={10}
          justifyCenter
          alignCenter
          height={40}
          font="16px unimed_slabregular"
          type="submit"
          onClick={clearParams}
        >
          Limpar
        </Button>

        <Button
          justifySpaceAround
          alignCenter
          font="16px unimed_slabregular"
          width={180}
          onClick={handleNovoRelatorio}
        >
          Gerar Relatório
        </Button>
      </ContButton>
    </FormContainer>
  );
}

export default FormRelatorioBeneficiario;
